var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M28 0H4a4 4 0 0 0-4 4v24a4 4 0 0 0 4 4h24a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M9.71 9C9.57 8.96 0 6.4 0 6.4v2.88h9.799c.082 0 .129-.006.129-.113 0-.078-.067-.127-.218-.168m-2.847 6.464c0-.603.08-.91.577-1.087l10.465-3.135a.04.04 0 0 0 .029-.04v-.874c0-.26-.113-.407-.294-.407-.102 0-.322.039-.36.044 0 0-12.306 1.76-12.745 1.827a.783.783 0 0 0-.692.806v4.99c0 .439.342.722.767.638l2.22-.436a.04.04 0 0 0 .033-.04zm4.672 2.161c-.466.265-.647.647-.647 1.101v5.432c0 .41.42.603.742.404l5.175-3.183.006.004.003.003 2.363 1.604a.168.168 0 0 0 .093.031c.074 0 .131-.04.154-.118l1.11-3.817.009-.006 2.868-1.764c.378-.232.608-.64.608-1.078v-4.811c0-.358-.203-.546-.466-.546-.15 0-.228.047-.296.086l-11.722 6.658"
}))));
export default SvgLogo;